import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import AutTable from '../../blocks/aut-grid-table/index';
import Conditional from '../../common/conditional';
import Form from '../../common/form';
import HelideckDropTestItem from './helideckDropTestItem';

import * as data from '../../../utils/data';
import * as models from '../../../utils/models';

class HelideckDropTestItemsForm extends Form {
	state = {
		data: { items: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		items: Joi.array()
			.min(1)
			.items(
				Joi.object({
					id: Joi.number().positive().required().label('ID'),
					netNumber: Joi.string().allow('').required().label('Net Number'),
					observation: Joi.string().min(10).required().label('Observation'),
					result: Joi.string().required().label('Result'),
				})
			)
			.required()
			.label('Inspection Items'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
		tableColumns: PropTypes.array,
	};

	onAddItem = (item: models.HelideckDropTestItem) => {
		const data: any = { ...this.state.data };
		data.items = [...data.items];
		data.items.push({ ...item, id: data.items.length + 1 });

		this.setState({ data });
	};

	onDeleteItem = (item: models.HelideckDropTestItem): void => {
		const data = { ...this.state.data };
		data.items = data.items.filter(
			(i: models.HelideckDropTestItem) => i.id !== item.id
		);

		this.setState({ data });
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data.items);

		this.setState({ data: { items: [] } });
	};

	render() {
		return (
			<React.Fragment>
				<HelideckDropTestItem onAdd={this.onAddItem} />

				<AutTable
					tableColumns={data.getHelideckDTColumns()}
					data={this.state.data.items}
					onDeleteItem={this.onDeleteItem}
				/>

				<Conditional isVisible={this.state.data.items.length > 0}>
					<form autoComplete="off" onSubmit={this.handleSubmit}>
						{this.renderButton('Finish')}
					</form>
				</Conditional>
			</React.Fragment>
		);
	}
}

export default HelideckDropTestItemsForm;
